import { FetchLogin, FetchLogout } from "_private/api/login";
import auth from "_private/auth";

const user = {
  state: {
    userId: "",
    userCode: "",
    userName: "",
    rememberMe: "",
    verifyCode: "",
    subModuleTitle: "",
    userSourceType: "",
    corpId: "",
  },
  mutations: {
    SET_USER_ID(state, payload) {
      state.userId = payload;
    },
    SET_USER_CODE(state, payload) {
      state.userCode = payload;
    },
    SET_USER_NAME(state, payload) {
      state.userName = payload;
    },
    SET_REMEMBER_ME(state, payload) {
      state.rememberMe = payload;
    },
    SET_VERIFY_CODE(state, payload) {
      state.verifyCode = payload;
    },
    SET_SUB_MODULE_TITLE(state, payload) {
      state.subModuleTitle = payload;
    },
    SET_USER_SOURCE_TYPE(state, payload) {
      state.userSourceType = payload;
    },
    SET_USER_CORP_ID(state, payload) {
      state.corpId = payload;
    },
  },
  actions: {
    setUserInfoAct({ commit }, payload) {
      const {
        userId = "",
        userCode = "",
        userName = "",
        rememberMe = "",
        verifyCode = "",
        subModuleTitle = "",
        userSourceType = "",
        corpId = "",
      } = payload; // 用户信息设置默认值，防止获取对象的 value 为 undefined
      commit("SET_USER_ID", userId);
      commit("SET_USER_CODE", userCode);
      commit("SET_USER_NAME", userName);
      commit("SET_REMEMBER_ME", rememberMe);
      commit("SET_VERIFY_CODE", verifyCode);
      commit("SET_SUB_MODULE_TITLE", subModuleTitle);
      commit("SET_USER_SOURCE_TYPE", userSourceType);
      commit("SET_USER_CORP_ID", corpId);
    },
    loginAct({ dispatch }, data) {
      auth.removeStore(); // 登录之前移除 vuex 数据
      return new Promise((resolve, reject) => {
        FetchLogin(data)
          .then((response) => {
            if (response.code === 1) {
              let result = response.result;
              auth.setUserInfoAct(result);
              dispatch("setUserInfoAct", result);
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    logoutAct() {
      return new Promise((resolve, reject) => {
        FetchLogout()
          .then((response) => {
            auth.removeUserInfo();
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default user;
